<template>
  <div>
    <div v-if="showTestimonials">
      <testimonials/>
    </div>
    <div v-if="showResources">
      <resources/>
    </div>
    <div v-if="showRequirements">
      <pro-requirements/>
    </div>
    <div v-else>
      <stock-report
          v-if="reports && !showResources && !showTestimonials"
          :reports="reports"
          :pros-needed="prosNeeded"
          :pros-current="prosCurrent"
          :last-updated="lastUpdated"
          :store-city="storeCity"/>
    </div>
  </div>
</template>

<script>
import { format as formatDate } from 'date-fns';
import { getProDemandReport } from '@homeservices/api-kit/search/demand';
import StockReport from './components/StockReport';
import Testimonials from './components/Testimonials';
import Resources from './components/Resources';
import ProRequirements from './components/Requirements';

export default {
  name: 'pro-desk-reporting',
  components: {
    StockReport,
    Testimonials,
    Resources,
    ProRequirements,
  },
  data () {
    return {
      reports: null,
    };
  },
  computed: {
    showTestimonials () {
      return this.$route.meta.showTestimonials;
    },
    showResources () {
      return this.$route.meta.showResources;
    },
    showRequirements () {
      return this.$route.meta.showRequirements;
    },
    lastUpdated () {
      const date = this.reports && this.reports.length && this.reports[0].created_date;
      return date ? formatDate(new Date(date), 'MMMM do, yyyy') : '';
    },
    prosNeeded () {
      if (this.reports) {
        return this.reports.reduce((sum, report) => sum + report.matches_to_find, 0);
      }
      return 0;
    },
    prosCurrent () {
      if (this.reports) {
        return this.reports.reduce((sum, report) => sum + report.available_pros, 0);
      }
      return 0;
    },
    storeCity () {
      if (this.reports && this.reports.length) {
        return this.reports[0].store_city;
      }

      return '';
    },
  },
  mounted () {
    this.fetchReports(this.$route.params.storeId);
  },
  methods: {
    async fetchReports (storeId) {
      this.reports = null;
      const response = await getProDemandReport({ storeId, hide_onboardable_by_agent: true });
      // Filter out Water Heater Installer from report (occupation_id 216)
      this.reports = response.data.results
        .filter(result => result.occupation_id !== 216)
        .filter(result => result.occupation_name);
    },
  },
};
</script>
